require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-daryl-thayil.json") })
        }
      }, "path---blog-author-daryl-thayil");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-daryl-thayil!./.cache/json/blog-author-daryl-thayil.json
// module id = 624
// module chunks = 231608221292675